import { useEffect } from 'react';
import { scrollToElement } from '../../utils';
import { ScrollableAnchorId } from '../../constants';
import { useLocation } from 'react-router-dom';

export default function ScrollProvider() {
    const { pathname } = useLocation();

    useEffect(() => {
        scrollToElement(ScrollableAnchorId);
    }, [pathname]);

    return null;
}